import { createI18n } from 'vue-i18n'
import { getUserFromCache } from '@/stores/userStore'
import en from '../languages/en.json'
import da from '../languages/da.json'

export class languageService {

    static DefaultUilanguage = 'en'

    public static getLanguages() {
        return ['da', languageService.DefaultUilanguage]
    }

    public static getLocale() {
        let userLocale = this.getBrowserLocale();
        const user = getUserFromCache();

        if (user != null) {
            if (user.interfaceLanguage != '') {
                userLocale = user.interfaceLanguage
            }
        }

        return userLocale;
    }

    private static getBrowserLocale() {
        const userLocale = navigator.language;
        const availableLanguages = this.getLanguages();

        if (!availableLanguages.includes(userLocale)) {
            return this.DefaultUilanguage;
        }

        return userLocale;
    }

    public static getMessages() {
        const messages = {
            en: en,
            da: da,
        }

        return messages;
    }

    public static getI18n() {
        const i18n = createI18n({
            locale: this.getLocale(),
            fallbackLocale: 'en',
            messages: this.getMessages()
        })
        return i18n;
    }

    public static setLocale(i18n: any ,newLocale: string) {
        i18n.locale = newLocale;
    }

}